import { ReactNode, useMemo } from "react";

import { IGIREMenuItem } from "@/router/models/router.types";
import { cn } from "@/styles/cn";

import { EndMenu } from "./EndMenu";
import { StartMenu } from "./StartMenu";

type Props = {
  className?: string;
  end?: ReactNode | (() => ReactNode);
  model: IGIREMenuItem[];
};

export function Menubar(props: Props) {
  const { model: items, end, className } = props;

  const { startItems, endItems } = useMemo(() => {
    const startItems = items?.filter((item) => (item.align ?? "start") === "start") ?? [];
    const endItems = items?.filter((item) => item.align === "end") ?? [];
    return { startItems, endItems };
  }, [items]);

  return (
    <div className={cn("flex h-[50px] border-b border-[#E4E4E4] px-3", className)}>
      <div className="flex flex-1">
        {startItems.map((item) => (
          <StartMenu key={item.label} item={item} />
        ))}
      </div>
      <div className="flex flex-1 justify-end">
        {endItems.map((item) => (
          <EndMenu key={item.label} item={item} />
        ))}

        {endItems.length > 0 && end && (
          <div className="my-2 ml-1 w-[1px] border-l border-[#E4E4E4] px-1" />
        )}

        {typeof end === "function" ? end() : end}
      </div>
    </div>
  );
}
